import { client } from '../../../actions';
import { authHeader } from '../../../helpers/auth-header';

export const setCompanyDocumentReminderSetting = async ({
  companyId,
  notificationTypeIds,
}) => {
  return client.post(
    '/docs/company_notification_type',
    {
      id: companyId,
      notificationTypeIds,
    },
    {
      headers: authHeader(),
    }
  );
};
